import React, { useState } from 'react';
import '../../style/tooltip.scss';

export const CustomTooltip = ({ children, content, isView, position }) => {
    return (
        <div className={`custom-tooltip-container ${position || ''}`}>
            {children}
            {isView && (
                <div className="custom-tooltip">
                    {content}
                </div>
            )}
        </div>
    );
};